// Utils
import request from '~/utils/request';
import { appendSortParams } from '~/utils/sort-params';
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Actions Types
import { SET_CAMPAIGNS_DATA, SET_CAMPAIGNS_LOADER } from './action-types';

const fetchCampaigns = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_CAMPAIGNS_LOADER, payload: true });

    let url = 'automations';

    let queryPayload = {
      page: payload?.pagination?.page ? payload.pagination.page : DEFAULT_PAGINATION.page,
      pageSize: payload?.pagination?.pageSize
        ? payload.pagination.pageSize
        : DEFAULT_PAGINATION.pageSize,
    };

    if (payload?.search?.length) {
      queryPayload.search = payload.search;
    }

    appendSortParams(queryPayload, payload);

    const response = await request.get(url, queryPayload);

    if (response.status === 200) {
      const responseData = response.data.data || {};
      const rows = Array.isArray(responseData.rows) ? responseData.rows : [];
      const combinedData = rows.map((campaign, i) => {
        const steps = Array.isArray(campaign?.config?.steps) ? campaign.config.steps : [];

        return {
          key: i,
          campaignId: campaign.id,
          name: campaign.name,
          orgId: campaign.orgId,
          createdBy: campaign.createdBy,
          creator: campaign.creator,
          description: campaign.description,
          createdAt: campaign.createdAt,
          isLiveMode: campaign.isLiveMode,
          meta: campaign.meta,
          updatedAt: campaign.updatedAt,
          updatedBy: campaign.updatedBy,
          noOfOrders: campaign.noOfOrders,
          templates: steps
            .filter((step) => step?.type === 'action')
            .map((step) => ({
              ...step?.meta?.selectedTemplate,
              productId: step?.productId,
              selectedEnvelope: step?.meta?.selectedEnvelope,
              selectedPostage: step?.meta?.selectedPostage,
            })),
        };
      });
      const campaigns = {
        rows: combinedData,
        count: responseData.count || 0,
        totalRecordsInDB: responseData.totalRecordsInDB || 0,
        to: responseData.to || null,
        from: responseData.from || null,
        currentPage: responseData.currentPage || DEFAULT_PAGINATION.page,
        lastPage: responseData.lastPage || 1,
        perPage: responseData.perPage || DEFAULT_PAGINATION.pageSize,
        totalRevenue: responseData.totalRevenue || 0,
        totalQuantity: responseData.totalQuantity || 0,
      };
      dispatch({ type: SET_CAMPAIGNS_DATA, payload: campaigns });
    }
  } catch (error) {
    return error;
  } finally {
    dispatch({ type: SET_CAMPAIGNS_LOADER, payload: false });
  }
};

const deleteCampaign = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_CAMPAIGNS_LOADER, payload: true });

    const response = await request.delete(`automations/${payload}`);
    return response;
  } catch (error) {
    return error;
  } finally {
    dispatch({ type: SET_CAMPAIGNS_LOADER, payload: false });
  }
};

const duplicateCampaign = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_CAMPAIGNS_LOADER, payload: true });

    const response = await request.post(`automations/${payload.id}/duplicate`, {
      name: payload.name,
    });
    return response;
  } catch (error) {
    return error;
  } finally {
    dispatch({ type: SET_CAMPAIGNS_LOADER, payload: false });
  }
};

export { fetchCampaigns, deleteCampaign, duplicateCampaign };
